import { Component } from '@angular/core'
import * as R from 'ramda'
import { MatDialogRef } from '@angular/material/dialog'
import { Store } from '@ngrx/store'
import * as fromRoot from '@tv3/store/state'
import { ParsedUploadFile } from '@tv3/interfaces/files/parsed-upload.file'
import { Toaster } from '@tokeet/tv3-platform'
import { TaskRequest } from '@tv3/interfaces/requests/task-request'
import { AddTasks } from '@tv3/store/task/task.actions'
import { CsvFileColumnDef, CsvFileParserGuide } from '@tv3/interfaces/files/csv-file-parser.file'
import {
  generateDateParser,
  generateMappingParser,
  parseString,
} from '@tv3/shared/csv-file-parser/csv-data-parse-helper'
import * as moment from 'moment'

@Component({
  selector: 'app-import-task-dialog',
  templateUrl: './import-task-dialog.component.html',
  host: { class: 'modal-content' },
  styleUrls: ['./import-task-dialog.component.scss'],
})
export class ImportTaskDialogComponent {
  files: ParsedUploadFile<TaskRequest>[] = []

  columnDefs: CsvFileColumnDef[] = <CsvFileColumnDef[]>[
    { name: 'Name', field: 'name', required: true, parse: parseString },
    { name: 'Due', field: 'due', required: true, parse: generateDateParser('DD-MMM-YYYY HH:mm') },
    { name: 'List', field: 'list', required: true, parse: parseString },
    { name: 'User Id', field: 'user_id', required: true, parse: parseString },
    { name: 'Inquiry Id', field: 'inquiry_id', parse: parseString },
    { name: 'Notes', field: 'notes', parse: parseString },
    { name: 'Status', field: 'status', parse: generateMappingParser({ finished: 2, unfinished: 1 }), default: 1 },
  ]

  guide: CsvFileParserGuide = {
    description: `The columns in your CSV file should be (${R.map(
      (col) => (!col.required ? col.name : col.name + '*'),
      this.columnDefs
    ).join(', ')}).`,
    list: ['Name, Due, List and User Id are required.', 'Due format "DD-MMM-YYYY HH:mm", such as "12-Jan-2016 15:11".'],
    sample: [
      ['Name', 'Due', 'List', 'User Id', 'Inquiry Id', 'Notes', 'Status'],
      [
        'Iris Ferguson',
        '2016-02-14 13:30',
        'list 1',
        'a3f19b90-64cb-4506-b269-cb9c7d0c254e',
        'ba51e3e7-fac2-4a0b-a0b9-74030a518be9',
        'Note 1',
        'Finished',
      ],
      [
        'Kinley Weiss',
        '2016-02-14 14:30',
        'list 2',
        'a3f19b90-64cb-4506-b269-cb9c7d0c254e',
        'ba51e3e7-fac2-4a0b-a0b9-74030a518be9',
        'Note 2',
        '',
      ],
    ],
  }

  constructor(
    public dialogRef: MatDialogRef<ImportTaskDialogComponent>,
    private store: Store<fromRoot.State>,
    protected toast: Toaster
  ) {}

  close() {
    this.dialogRef.close()
  }

  onCsvFilesParsed(files: ParsedUploadFile<any>[]) {
    this.files = files
  }

  create() {
    if (R.any((file) => file.isError, this.files)) {
      this.toast.error('There are some errors in selected file(s) needs to be checked.')
      return
    }

    //  get parsed csv data
    let items: any[] = R.filter(
      (i) => !R.isEmpty(i),
      R.map((i) => i.item, R.flatten<any>(R.map((file) => file.items, this.files)))
    )
    items = R.map((item: any) => {
      item.due = moment(item.due).unix()
      return item
    }, items)

    this.store.dispatch(AddTasks({ requests: items }))

    this.close()
  }
}
